(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  /**
   * VIBRANTA â€“ Glass Island Header
   * ZastÄ™puje StickyHeader z Dawn (ta sama nazwa elementu, kompatybilne API).
   */
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.onScroll = this.onScroll.bind(this);
      this.update = this.update.bind(this);
      this.onResize = this.onResize.bind(this);
      this.onPointerMove = this.onPointerMove.bind(this);
      this.onPointerOver = this.onPointerOver.bind(this);
      this.onPointerLeave = this.onPointerLeave.bind(this);
      this.onPointerDown = this.onPointerDown.bind(this);
      this.onFocusIn = this.onFocusIn.bind(this);
      this.onFocusOut = this.onFocusOut.bind(this);
      this.fitNav = this.fitNav.bind(this);
      this.scheduleFit = this.scheduleFit.bind(this);
    }

    connectedCallback() {
      this.header = this.closest('.section-header') || document.querySelector('.section-header');
      if (!this.header) return;

      this.headerIsAlwaysSticky = true;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.island = this.querySelector('.vb-fx__island');
      this.progress = this.querySelector('.vb-fx__progress');
      this.pill = this.querySelector('.vb-pill');
      this.tip = this.querySelector('.vb-tip');
      this.cart = this.querySelector('#cart-icon-bubble');

      this.mqDesktop = window.matchMedia('(min-width: 990px)');
      this.mqHover = window.matchMedia('(hover: hover) and (pointer: fine)');
      this.mqReduce = window.matchMedia('(prefers-reduced-motion: reduce)');

      this.condensed = false;
      this.ticking = false;
      this.hovering = false;
      this.lastProgress = -1;
      this.pillOn = false;
      this.activeItem = null;
      this.tipOn = false;
      this.tipIcon = null;
      this.natural = null;

      this.header.classList.add('shopify-section-header-sticky', 'vb-instant');
      this.classList.add('vb-js');

      this.measure();
      this.update();
      requestAnimationFrame(() =>
        requestAnimationFrame(() => this.header && this.header.classList.remove('vb-instant'))
      );

      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onResize, { passive: true });
      this.addEventListener('pointermove', this.onPointerMove, { passive: true });
      this.addEventListener('pointerover', this.onPointerOver, { passive: true });
      this.addEventListener('pointerleave', this.onPointerLeave, { passive: true });
      this.addEventListener('pointerdown', this.onPointerDown, { passive: true });
      this.addEventListener('focusin', this.onFocusIn);
      this.addEventListener('focusout', this.onFocusOut);

      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(() => {
          this.measureScroll();
          this.onScroll();
        });
        this.resizeObserver.observe(document.body);
      }

      if (this.cart && 'MutationObserver' in window) {
        this.cartObserver = new MutationObserver(() => this.bumpCart());
        this.cartObserver.observe(this.cart, { childList: true });
      }

      // menu w jednej linii: dobĂłr zagÄ™szczenia (Buddha wstawia pozycje asynchronicznie)
      this.fitNav();
      const nav = this.querySelector('.header__inline-menu');
      if (nav && 'MutationObserver' in window) {
        this.navObserver = new MutationObserver(this.scheduleFit);
        this.navObserver.observe(nav, { childList: true, subtree: true });
      }
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(this.scheduleFit);
      window.addEventListener('load', this.scheduleFit, { once: true });
      window.addEventListener('load', () => this.header && (this.measureIsland(), this.measureComp(), this.setHeaderHeight()), { once: true });
      this.fitTimer = setTimeout(this.scheduleFit, 1500);
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onResize);
      if (this.resizeObserver) this.resizeObserver.disconnect();
      if (this.cartObserver) this.cartObserver.disconnect();
      cancelAnimationFrame(this.fitRaf);
      clearTimeout(this.fitTimer);
      if (this.navObserver) this.navObserver.disconnect();
      cancelAnimationFrame(this.trackRaf);
      cancelAnimationFrame(this.resizeRaf);
      clearTimeout(this.pillTimer);
      clearTimeout(this.tipTimer);
      clearTimeout(this.bumpTimer);
    }

    /* ---------- pomiary ---------- */
    measure() {
      const rect = this.header.getBoundingClientRect();
      const y = window.scrollY || 0;
      if (!this.condensed && (rect.top > 0.5 || y < 1)) {
        this.natural = Math.max(0, rect.top + y);
      } else if (this.natural === null) {
        this.natural = this.offsetAbove();
      }
      this.measureScroll();
      this.measureIsland();
      this.measureComp();
      this.setHeaderHeight();
    }

    // wyspa ma szerokoĹ›Ä‡ faktycznego headera (dziaĹ‚a teĹĽ przy wĹ‚asnym max-width na .header)
    measureIsland() {
      const headerEl = this.querySelector('.header');
      if (!headerEl) return;
      const hb = headerEl.getBoundingClientRect();
      const wb = this.getBoundingClientRect();
      this.style.setProperty('--vb-hl', `${Math.max(0, Math.round(hb.left - wb.left))}px`);
      this.style.setProperty('--vb-hr', `${Math.max(0, Math.round(wb.right - hb.right))}px`);
    }

    // o ile header jest niĹĽszy na wyspie â€“ mierzone, wiÄ™c dziaĹ‚a przy kaĹĽdym ukĹ‚adzie (telefon/desktop)
    measureComp() {
      const s = this.header;
      const wasCondensed = s.classList.contains('vb-is-condensed');
      const hadInstant = s.classList.contains('vb-instant');
      s.classList.add('vb-instant');
      s.classList.remove('vb-is-condensed');
      const full = s.getBoundingClientRect().height;
      s.classList.add('vb-is-condensed');
      const condensed = s.getBoundingClientRect().height;
      if (!wasCondensed) s.classList.remove('vb-is-condensed');
      s.style.setProperty('--vb-comp', `${Math.round((full - condensed) * 100) / 100}px`);
      void s.offsetHeight;
      if (!hadInstant) s.classList.remove('vb-instant');
    }

    offsetAbove() {
      let total = 0;
      for (let el = this.header.previousElementSibling; el; el = el.previousElementSibling) {
        const cs = window.getComputedStyle(el);
        if (cs.display === 'none' || cs.position === 'fixed' || cs.position === 'absolute') continue;
        total += el.getBoundingClientRect().height + (parseFloat(cs.marginTop) || 0) + (parseFloat(cs.marginBottom) || 0);
      }
      return total;
    }

    measureScroll() {
      this.scrollMax = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
    }

    setHeaderHeight() {
      // wysokoĹ›Ä‡ "peĹ‚na" = aktualna wysokoĹ›Ä‡ + aktualna kompensacja (staĹ‚a w kaĹĽdej klatce)
      const cs = window.getComputedStyle(this.header);
      const extra = (parseFloat(cs.marginBottom) || 0) - (parseFloat(cs.getPropertyValue('--vb-mb')) || 0);
      document.documentElement.style.setProperty('--header-height', `${Math.round(this.header.offsetHeight + extra)}px`);
    }

    /* ---------- scroll ---------- */
    onScroll() {
      if (this.ticking) return;
      this.ticking = true;
      requestAnimationFrame(this.update);
    }

    update() {
      this.ticking = false;
      if (!this.header) return;

      const y = window.scrollY || document.documentElement.scrollTop || 0;
      const searchOpen = this.predictiveSearch && this.predictiveSearch.isOpen;

            const dok = this.sprawdzDok();
      if (!searchOpen && !this.header.classList.contains('menu-open')) {
        const base = this.natural || 0;
        if (dok) { if (this.condensed) this.setCondensed(false); }
        else if (!this.condensed && y > base + 40) this.setCondensed(true);
        else if (this.condensed && y < base + 8) this.setCondensed(false);
      }

      if (this.progress) {
        const p = this.scrollMax > 0 ? Math.min(1, Math.max(0, y / this.scrollMax)) : 0;
        if (Math.abs(p - this.lastProgress) > 0.0005) {
          this.progress.style.transform = `scaleX(${p.toFixed(4)})`;
          this.lastProgress = p;
        }
      }

      if (this.tipOn || this.tipTimer) this.hideTip();
    }



           /* ---------- sczepienie z sekcją na końcu strony ([data-vb-dok], np. „Vibranta – koniec strony”) ----------
       Przez ostatnie DOK_DROGA px przewijania wyspa menu i sekcja (karta tej samej szerokości co wyspa) rozszerzają się razem
       do pełnej szerokości, rogi się prostują, szkło przechodzi w pełny kolor – ruch przypięty 1:1 do przewijania, więc
       w górę cofa się tak samo. W chwili styku menu przechodzi w pełną formę (klasa vb-dok) i krótko „klika”.
       Tylko gdy cała sekcja mieści się pod menu (telefon z wysoką sekcją: zwykła wyspa, menu nie znika). */
    sprawdzDok() {
      const el = this.dokEl && this.dokEl.isConnected ? this.dokEl : (this.dokEl = document.querySelector('[data-vb-dok]'));
      if (!el) { if (this.dok) this.ustawDok(false); return false; }
      const r = el.getBoundingClientRect();
      const top = r.top;
      // geometria wyspy: wartości docelowe z tokenów (pewne także w trakcie przejścia), dół wyspy – zmierzony
      if (this.condensed && !this.dok && !this.dokP) {
        const d = Math.round(this.header.getBoundingClientRect().bottom);
        if (d > 0 && d !== this.wyspaDol) {
          this.wyspaDol = d;
          // zapis zmiennej na <html> przelicza style całej strony (~20 ms) – robimy go raz, gdy dół wyspy przestanie się
          // zmieniać, a nie w każdej klatce przejścia header ⇄ wyspa (skrypt sam korzysta od razu z this.wyspaDol)
          clearTimeout(this.wyspaTimer);
          this.wyspaTimer = setTimeout(() => document.documentElement.style.setProperty('--vb-wyspa-dol', `${this.wyspaDol}px`), 180);
        }
      }
      const linia = this.wyspaDol || this.header.getBoundingClientRect().bottom;
      const miesci = el.offsetHeight <= window.innerHeight - linia + 1;
      if (!miesci) { this.dokRysuj(el, r, 1, false); if (this.dok) this.ustawDok(false); return false; }
      const DOK_DROGA = 110;
      const p = this.mqReduce.matches ? (top <= linia ? 1 : 0) : Math.min(1, Math.max(0, (linia + DOK_DROGA - top) / DOK_DROGA));
      const stan = this.dok ? p > 0.8 : p >= 1;                   // odklejenie dopiero ~20 px wyżej – bez migania na granicy
      if (stan !== !!this.dok) {
        this.ustawDok(stan);
        // odklejenie: od razu wyspa, a jej kształt dalej prowadzi przewijanie (bez przejścia klas w tle)
        if (!stan && !this.condensed && !this.header.classList.contains('menu-open')) this.setCondensed(true);
      }
      this.dokRysuj(el, r, stan ? 1 : p, true);
      if (this.header.style.transform) this.header.style.transform = '';   // menu po sczepieniu zawsze w całości na górze
      return stan;
    }

    // jedna klatka przemiany: p = 0 (wyspa i karta) … 1 (jeden blok na pełną szerokość)
    dokRysuj(el, r, p, aktywny) {
      const widac = r.top < window.innerHeight && r.bottom > 0;
      const cs = getComputedStyle(this.header);
      const side = parseFloat(cs.getPropertyValue('--vb-side')) || 16;
      const gap = parseFloat(cs.getPropertyValue('--vb-gap')) || 12;
      const rad = parseFloat(cs.getPropertyValue('--vb-radius')) || 18;
      const L = Math.max(side, parseFloat(this.style.getPropertyValue('--vb-hl')) || 0);
      const R = Math.max(side, parseFloat(this.style.getPropertyValue('--vb-hr')) || 0);
      const e = p * p * (3 - 2 * p), q = 1 - e;                    // łagodny start i lądowanie, w środku 1:1 z przewijaniem
      if (el.style.clipPath) el.style.clipPath = '';                // sekcja zawsze na pełnej szerokości
      // wyspa: tylko w trakcie zbliżania (0 < p < 1, menu jeszcze wyspą) – poza tym rządzą klasy i ich przejścia
      const isl = this.island, warstwy = this.dokWarstwy || (this.dokWarstwy = ['glass', 'solid', 'tint', 'grain', 'edge', 'line'].map((n) => this.querySelector(`.vb-fx__${n}`)));
      const steruj = aktywny && isl && this.condensed && !this.dok && p > 0 && p < 1;
      if (steruj) {
        isl.style.transition = 'none';
        isl.style.top = `${(gap * q).toFixed(1)}px`; isl.style.left = `${(L * q).toFixed(1)}px`; isl.style.right = `${(R * q).toFixed(1)}px`;
        isl.style.borderRadius = `${(rad * q).toFixed(1)}px`;
        isl.style.boxShadow = `0 22px 44px -22px rgba(0,0,0,${(0.85 * q).toFixed(3)}), 0 16px 42px -20px rgba(var(--vb-accent),${(0.45 * q).toFixed(3)})`;
        const [glass, solid, tint, grain, edge, line] = warstwy;
        const op = (n, v) => { if (n) { n.style.transition = 'none'; n.style.opacity = v.toFixed(3); } };
        op(glass, q); op(solid, e); op(tint, q); op(grain, 0.06 * q); op(edge, q); op(line, q);
        if (solid) solid.style.background = '#171719';
        this.dokP = true;
      } else if (this.dokP) {
        // koniec sterowania: oddajemy wyspę klasom bez skoku (wartości końcowe = wartości z CSS)
        this.dokP = false;
        [isl].concat(warstwy).forEach((n) => { if (n) ['transition', 'top', 'left', 'right', 'borderRadius', 'boxShadow', 'opacity', 'background'].forEach((k) => { n.style[k] = ''; }); });
      }
    }

    ustawDok(stan) {
      this.dok = stan;
      if (stan) {
        // styk: kształt wyspy jest już pełny (narysowany przewijaniem) – klasa przejmuje go bez skoku
        this.header.classList.add('vb-dok');
      } else {
        this.header.classList.remove('vb-dok');
        this.header.style.transform = '';
      }
      if (stan && !this.mqReduce.matches) {
        this.header.classList.remove('vb-dok-uderz'); void this.header.offsetWidth; this.header.classList.add('vb-dok-uderz');
        clearTimeout(this.dokTimer); this.dokTimer = setTimeout(() => this.header && this.header.classList.remove('vb-dok-uderz'), 500);
      }
      document.dispatchEvent(new CustomEvent('vibranta:dok', { detail: { dok: stan } }));
    }









    setCondensed(state) {
      this.condensed = state;
      this.header.classList.toggle('vb-is-condensed', state);
      this.header.classList.toggle('scrolled-past-header', state);
      if (this.pillOn && this.activeItem) this.trackPill(750);
      this.dispatchEvent(new CustomEvent('vibranta:header', { bubbles: true, detail: { condensed: state } }));
    }

    onResize() {
      cancelAnimationFrame(this.resizeRaf);
      this.resizeRaf = requestAnimationFrame(() => {
        this.fitNav();
        this.measure();
        this.hideTip();
        this.hidePill(true);
        this.onScroll();
      });
    }

    /* ---------- menu w jednej linii ---------- */
    scheduleFit() {
      cancelAnimationFrame(this.fitRaf);
      this.fitRaf = requestAnimationFrame(this.fitNav);
    }

    fitNav() {
      this.fitRaf = 0;
      const nav = this.querySelector('.header__inline-menu');
      const list = nav && nav.querySelector('ul');
      if (!list || !this.mqDesktop.matches) {
        this.removeAttribute('data-vb-fit');
        return;
      }
      const wraps = () => {
        const items = [...list.children].filter((li) => li.getClientRects().length);
        if (items.length < 2) return false;
        const top = items[0].offsetTop;
        return items.some((li) => Math.abs(li.offsetTop - top) > 4);
      };
      for (let level = 0; level <= 4; level++) {
        this.setAttribute('data-vb-fit', String(level));
        if (!wraps()) break;
      }
      if (this.pillOn) this.hidePill(true);
    }

    /* ---------- kursor ---------- */
    canHover() {
      return this.mqHover.matches && this.mqDesktop.matches;
    }

    onPointerMove(event) {
      if (event.pointerType === 'touch' || !this.canHover()) return;
      this.hovering = true;
    }

    onPointerLeave() {
      this.hovering = false;
      this.schedulePillHide();
      this.hideTip();
    }

    onPointerDown() {
      this.hideTip();
    }

    onPointerOver(event) {
      if (event.pointerType === 'touch' || !this.canHover()) return;

      const item = this.menuItemFrom(event.target);
      if (item) this.movePill(item);
      else if (this.pillOn) this.schedulePillHide();

      const icon = this.iconFrom(event.target);
      if (icon) this.queueTip(icon);
      else if (this.tipOn || this.tipTimer) this.hideTip();
    }

    /* ---------- menu: pĹ‚ynny pill ---------- */
    menuItemFrom(node) {
      if (!node || !node.closest) return null;
      const nav = node.closest('.header__inline-menu');
      if (!nav || !this.contains(nav)) return null;
      const list = nav.querySelector('ul');
      let li = node.closest('li');
      while (li && li.parentElement !== list) {
        li = li.parentElement ? li.parentElement.closest('li') : null;
      }
      if (!li || !nav.contains(li)) return null;
      return (
        li.querySelector(':scope > a, :scope > header-menu summary, :scope > details > summary, :scope > summary') || li
      );
    }

    movePill(target) {
      if (!this.pill) return;
      clearTimeout(this.pillTimer);
      this.pillTimer = null;
      if (this.pillOn && this.activeItem === target) return;

      const first = !this.pillOn;
      this.activeItem = target;
      if (first) this.pill.classList.add('is-instant');
      this.placePill(target);
      if (first) {
        void this.pill.offsetWidth;
        this.pill.classList.remove('is-instant');
      }
      this.pill.classList.add('is-on');
      this.pillOn = true;
    }

    placePill(target) {
      const host = this.getBoundingClientRect();
      const r = target.getBoundingClientRect();
      const s = this.pill.style;
      s.width = `${r.width.toFixed(2)}px`;
      s.height = `${r.height.toFixed(2)}px`;
      s.transform = `translate3d(${(r.left - host.left).toFixed(2)}px, ${(r.top - host.top).toFixed(2)}px, 0)`;
    }

    trackPill(duration) {
      if (!this.pill) return;
      cancelAnimationFrame(this.trackRaf);
      const end = performance.now() + duration;
      this.pill.classList.add('is-instant');
      const step = (now) => {
        if (!this.pillOn || !this.activeItem) {
          this.pill.classList.remove('is-instant');
          return;
        }
        this.placePill(this.activeItem);
        if (now < end) this.trackRaf = requestAnimationFrame(step);
        else this.pill.classList.remove('is-instant');
      };
      this.trackRaf = requestAnimationFrame(step);
    }

    schedulePillHide() {
      if (!this.pillOn) return;
      clearTimeout(this.pillTimer);
      this.pillTimer = setTimeout(() => {
        this.pillTimer = null;
        const held = this.querySelector('.header__inline-menu .mega-hover, .header__inline-menu details[open]');
        if (held && this.hovering) return this.schedulePillHide();
        this.hidePill();
      }, 160);
    }

    hidePill(force) {
      if (!this.pill || (!this.pillOn && !force)) return;
      clearTimeout(this.pillTimer);
      this.pillTimer = null;
      this.pill.classList.remove('is-on');
      this.pillOn = false;
      this.activeItem = null;
    }

    onFocusIn(event) {
      if (!this.mqDesktop.matches) return;
      const item = this.menuItemFrom(event.target);
      if (!item) return;
      let visible = true;
      try {
        visible = event.target.matches(':focus-visible');
      } catch (e) {}
      if (visible) this.movePill(item);
    }

    onFocusOut(event) {
      if (!this.hovering && !this.menuItemFrom(event.relatedTarget)) this.schedulePillHide();
    }

    /* ---------- podpowiedzi przy ikonach ---------- */
    iconFrom(node) {
      if (!node || !node.closest) return null;
      const el = node.closest('.header__icons a, .header__icons summary, .header__icons button');
      if (!el || !this.contains(el)) return null;
      if (el.closest('.search-modal, .modal__content, localization-form, [role="dialog"], .header__submenu, predictive-search')) {
        return null;
      }
      return el;
    }

    queueTip(icon) {
      if (this.tipIcon === icon && (this.tipOn || this.tipTimer)) return;
      clearTimeout(this.tipTimer);
      this.tipIcon = icon;
      this.tipTimer = setTimeout(() => {
        this.tipTimer = null;
        this.showTip(icon);
      }, this.tipOn ? 0 : 320);
    }

    showTip(icon) {
      if (!this.tip) return;
      const label = this.labelFor(icon);
      const r = icon.getBoundingClientRect();
      if (!label || icon.hasAttribute('title') || icon.closest('details[open]') || !r.width || r.width > 80) {
        this.hideTip();
        return;
      }
      const host = this.getBoundingClientRect();
      this.tip.textContent = label;
      const half = this.tip.offsetWidth / 2;
      const center = r.left + r.width / 2 - host.left;
      const x = Math.min(Math.max(center, half + 8), host.width - half - 8);
      this.tip.style.setProperty('--vb-tx', `${x.toFixed(1)}px`);
      this.tip.style.setProperty('--vb-ty', `${(r.bottom - host.top + 10).toFixed(1)}px`);
      this.tip.style.setProperty('--vb-ax', `${(center - x).toFixed(1)}px`);
      this.tip.classList.add('is-on');
      this.tipOn = true;
      this.tipIcon = icon;
    }

    hideTip() {
      clearTimeout(this.tipTimer);
      this.tipTimer = null;
      this.tipIcon = null;
      if (this.tip && this.tipOn) this.tip.classList.remove('is-on');
      this.tipOn = false;
    }

    labelFor(el) {
      const aria = (el.getAttribute('aria-label') || '').trim();
      if (aria) return aria;
      const hidden = el.querySelector('.visually-hidden');
      return hidden ? hidden.textContent.trim().replace(/\s+/g, ' ') : '';
    }

    /* ---------- koszyk ---------- */
    bumpCart() {
      if (!this.cart || this.mqReduce.matches) return;
      this.cart.classList.remove('vb-bump');
      void this.cart.offsetWidth;
      this.cart.classList.add('vb-bump');
      clearTimeout(this.bumpTimer);
      this.bumpTimer = setTimeout(() => this.cart && this.cart.classList.remove('vb-bump'), 1100);
    }

    /* ---------- zgodnoĹ›Ä‡ z API Dawn ---------- */
    hide() {}

    reveal() {}

    reset() {}

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close && disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal && this.searchModal.close) this.searchModal.close(false);
    }
  }

  if (!customElements.get('sticky-header')) customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
